import React, { useState } from "react"
import useStore from "src/v2/utils/store"
import CustomModal from "../ui-components/custom-modal"
import {
  dislikeIconFilled,
  dislikeIconUnfilled,
  likeIconFilled,
  likeIconUnfilled,
} from "src/components/icons-svg"
import CustomTooltip from "../ui-components/custom-tooltip"
import { InputLabel, TextField } from "@material-ui/core"
// @ts-ignore
import { useParams } from "react-router-dom"

export default function AskAIfeedback({
  type,
  submissionText,
  iconDimension = 28,
  showButton = false,
}) {
  const [AIresponseLiked, setAIresponseLiked] = useState(false)
  const [AIresponseDisliked, setAIresponseDisliked] = useState(false)
  const [openAIresponseFeedbackModal, setOpenAIresponseFeedbackModal] =
    useState(false)
  const [feedbackText, setFeedbackText] = useState("")
  const [feedbackTextHasError, setFeedbackTextHasError] = useState(false)
  const [feedbackTextErrorText, setFeedbackTextErrorText] = useState("")
  const [submittingAIfeedback, setSubmittingAIfeedback] = useState(false)

  const submitAIfeedback = useStore((state) => state.submitAIfeedback)
  const showToaster = useStore((state) => state.showToaster)
  const { reviewId } = useParams()

  const onLikeDislikeBtnClick = (response) => {
    if (response) {
      setAIresponseLiked(true)
      setAIresponseDisliked(false)
    } else {
      setAIresponseLiked(false)
      setAIresponseDisliked(true)
    }
    setOpenAIresponseFeedbackModal(true)
  }

  const onSubmitFeedback = async () => {
    if (!feedbackText || !feedbackText.trim()) {
      setFeedbackTextHasError(true)
      setFeedbackTextErrorText("Please enter some feedback")
      return
    } else {
      setFeedbackTextHasError(false)
      setFeedbackTextErrorText("")
    }
    try {
      setSubmittingAIfeedback(true)
      await submitAIfeedback({
        type,
        feedbackText,
        reviewId: reviewId,
        liked: AIresponseLiked,
      })
      showToaster && showToaster("info", `Thank you! ${submissionText}`)
      setSubmittingAIfeedback(false)
      onCloseFeedbackModal()
    } catch (err) {
      setSubmittingAIfeedback(false)
      // Optionally show error
    }
  }

  const onCloseFeedbackModal = () => {
    setOpenAIresponseFeedbackModal(false)
    setFeedbackText("")
    setFeedbackTextHasError(false)
    setFeedbackTextErrorText("")
  }

  return (
    <>
      <CustomModal
        size="medium"
        title="Feedback"
        showModal={openAIresponseFeedbackModal}
        onCloseModal={onCloseFeedbackModal}
        submitBtnText={"Submit"}
        onSubmit={onSubmitFeedback}
        submitBtnDisabled={false}
        loading={submittingAIfeedback}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            onSubmitFeedback()
          }}
        >
          <div style={{ marginTop: 15 }}>
            <InputLabel
              htmlFor="AIresponseFeedback"
              style={{ marginBottom: "12px" }}
            >
              Please provide additional information
            </InputLabel>
            <div>
              <TextField
                type="text"
                multiline
                fullWidth
                rows={4}
                id="AIresponseFeedback"
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                variant="outlined"
                disabled={false}
                error={feedbackTextHasError}
                helperText={feedbackTextErrorText}
                autoFocus={true}
              />
            </div>
          </div>
        </form>
      </CustomModal>

      <div style={{ display: "flex", marginBottom: 10 }}>
        <div
          style={{ marginRight: 5 }}
          onClick={() => onLikeDislikeBtnClick(true)}
        >
          {showButton ? (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.5,
                borderRadius: "8px",
                padding: "5px 10px",
                border: "1px solid #ccc",
                cursor: "pointer",
                backgroundColor: "transparent",
              }}
            >
              {AIresponseLiked
                ? likeIconFilled(iconDimension, 0.5)
                : likeIconUnfilled(iconDimension, 0.5)}
              <span style={{ marginLeft: "5px" }}>Good response</span>
            </button>
          ) : AIresponseLiked ? (
            <CustomTooltip title="Liked the AI response">
              {likeIconFilled(iconDimension, 0.5)}
            </CustomTooltip>
          ) : (
            <CustomTooltip title="Like the AI response">
              {likeIconUnfilled(iconDimension, 0.5)}
            </CustomTooltip>
          )}
        </div>
        <div onClick={() => onLikeDislikeBtnClick(false)}>
          {showButton ? (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.5,
                borderRadius: "8px",
                padding: "5px 10px",
                border: "1px solid #ccc",
                cursor: "pointer",
                backgroundColor: "transparent",
              }}
            >
              {AIresponseDisliked
                ? dislikeIconFilled(iconDimension, 0.5)
                : dislikeIconUnfilled(iconDimension, 0.5)}
              <span style={{ marginLeft: "5px" }}>Bad response</span>
            </button>
          ) : AIresponseDisliked ? (
            <CustomTooltip title="Disliked the AI response">
              {dislikeIconFilled(iconDimension, 0.5)}
            </CustomTooltip>
          ) : (
            <CustomTooltip title="Dislike the AI response">
              {dislikeIconUnfilled(iconDimension, 0.5)}
            </CustomTooltip>
          )}
        </div>
      </div>
    </>
  )
}
